var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSorry(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-1"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 428.22,
    y: 398.49,
    width: 21.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.56,
    y: 393.31,
    width: 34.11,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 44.53,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.88,
    y: 394.25,
    width: 11.14,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.58,
    y: 394.25,
    width: 38.39,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.31,
    y: 390.03,
    width: 27.7,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.69,
    y: 75.28,
    width: 162.65,
    height: 136.83,
    transform: "translate(292.02 287.38) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.82,
    y: 75.28,
    width: 164.71,
    height: 136.83,
    transform: "translate(286.35 287.38) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.69,
    y: 212.11,
    width: 162.65,
    height: 5.87,
    transform: "translate(292.02 430.08) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.37,
    y: 212.11,
    width: 164.71,
    height: 5.87,
    transform: "translate(273.45 430.08) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.18,
    y: 66.76,
    width: 125.99,
    height: 153.87,
    transform: "translate(286.87 0.52) rotate(90)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "157.67 206.69 142.59 80.7 119.06 80.7 134.14 206.69 157.67 206.69",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.6,201.3a.4.4,0,0,0,.39-.39V84.22a.39.39,0,1,0-.78,0V200.91A.4.4,0,0,0,217.6,201.3Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.09 206.69 114.01 80.7 104.83 80.7 119.91 206.69 129.09 206.69",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.58,
    y: 143.35,
    width: 125.99,
    height: 0.69,
    transform: "translate(210.27 77.11) rotate(90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59.54 90.91 222.18 90.91 222.68 82.8 60.04 82.8 59.54 90.91",
    style: {
      fill: "#ebebeb",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59.54 104.21 222.18 104.21 222.68 96.1 60.04 96.1 59.54 104.21",
    style: {
      fill: "#ebebeb",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59.54 117.51 222.18 117.51 222.68 109.4 60.04 109.4 59.54 117.51",
    style: {
      fill: "#ebebeb",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59.54 130.81 222.18 130.81 222.68 122.7 60.04 122.7 59.54 130.81",
    style: {
      fill: "#ebebeb",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59.54 144.12 222.18 144.12 222.68 136.01 60.04 136.01 59.54 144.12",
    style: {
      fill: "#ebebeb",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59.54 157.42 222.18 157.42 222.68 149.31 60.04 149.31 59.54 157.42",
    style: {
      fill: "#ebebeb",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.97,
    y: 98.53,
    width: 162.97,
    height: 109.45,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 424.95,
    y: 98.53,
    width: 3.83,
    height: 109.45,
    transform: "translate(853.72 306.51) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.27,
    y: 120.07,
    width: 32.5,
    height: 49.47,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "337.48 182.6 304.98 182.6 305.8 133.13 338.3 133.13 337.48 182.6",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372.83,
    y: 108.71,
    width: 32.5,
    height: 49.47,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.43 194.1 346.4 194.1 348.43 148.39 378.46 148.39 376.43 194.1",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.92,238.05s.77,22.32,30.19,22.32,30.19-22.32,30.19-22.32Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.86,
    y: 269.63,
    width: 42.66,
    height: 103.19,
    transform: "translate(844.37 642.44) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.95,
    y: 372.82,
    width: 210.37,
    height: 9.58,
    transform: "translate(660.28 755.22) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.76,
    y: 269.63,
    width: 184.09,
    height: 103.19,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.53,
    y: 282.18,
    width: 150.55,
    height: 31.75,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.53,
    y: 322.98,
    width: 150.55,
    height: 31.75,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.15,287.61h35.32a3.41,3.41,0,0,0,3.4-3.4h0a3.41,3.41,0,0,0-3.4-3.4H291.15a3.41,3.41,0,0,0-3.4,3.4h0A3.41,3.41,0,0,0,291.15,287.61Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.15,328.41h35.32a3.41,3.41,0,0,0,3.4-3.4h0a3.41,3.41,0,0,0-3.4-3.4H291.15a3.41,3.41,0,0,0-3.4,3.4h0A3.41,3.41,0,0,0,291.15,328.41Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.08,
    y: 260.37,
    width: 189.78,
    height: 9.25,
    transform: "translate(611.93 530) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.86,
    y: 260.37,
    width: 48.62,
    height: 9.25,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.76,
    y: 255.62,
    width: 60.27,
    height: 126.78,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.91,
    y: 318.49,
    width: 112.24,
    height: 1.05,
    transform: "translate(390.04 247.98) rotate(90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.5,
    y: 262.89,
    width: 47.84,
    height: 1.33,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.08,
    y: 255.62,
    width: 60.27,
    height: 126.78,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.36,
    y: 255.62,
    width: 6.01,
    height: 126.78,
    transform: "translate(378.73 638.02) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.23,
    y: 318.49,
    width: 112.24,
    height: 1.05,
    transform: "translate(451.36 186.66) rotate(90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.7,
    y: 319.02,
    width: 125.72,
    height: 1.05,
    transform: "translate(445.1 193.98) rotate(90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.82,
    y: 262.89,
    width: 47.84,
    height: 1.33,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.92,263.55h0a1.14,1.14,0,0,1,1.13,1.13v18.37a1.14,1.14,0,0,1-1.13,1.13h0a1.14,1.14,0,0,1-1.13-1.13V264.68A1.14,1.14,0,0,1,121.92,263.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.2,263.55h0a1.13,1.13,0,0,1,1.13,1.13v18.37a1.13,1.13,0,0,1-1.13,1.13h0a1.14,1.14,0,0,1-1.13-1.13V264.68A1.14,1.14,0,0,1,129.2,263.55Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-1",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304.14,273.13c3.46,16.29-15.1,23.18-22.81,16S274,260,263.6,259.42C278.61,247.8,300.77,257.28,304.14,273.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289,374.76a1.73,1.73,0,0,1-1.72-1.53c-3.84-32.31,1-109.49,40.58-141.85a1.74,1.74,0,1,1,2.2,2.69c-38.44,31.44-43.1,107.06-39.33,138.75a1.75,1.75,0,0,1-1.52,1.93Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.9,416.24h28.18a4.16,4.16,0,0,0,4.06-3.25l11.76-52.13a4.17,4.17,0,0,0-4.07-5.08H263.15a4.16,4.16,0,0,0-4.06,5.08L270.84,413A4.17,4.17,0,0,0,274.9,416.24Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.9,416.24h28.18a4.16,4.16,0,0,0,4.06-3.25l11.76-52.13a4.17,4.17,0,0,0-4.07-5.08H263.15a4.16,4.16,0,0,0-4.06,5.08L270.84,413A4.17,4.17,0,0,0,274.9,416.24Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301,276.38a1.9,1.9,0,0,1-.4-.05,1.73,1.73,0,0,1-1.29-2.08c0-.25,5.65-24.84-2.94-39.29a1.73,1.73,0,1,1,3-1.77C308.71,248.84,303,274,302.73,275A1.74,1.74,0,0,1,301,276.38Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.62,225.36c-.7,15.7,33.38,23.19,44.3,16.55s3.21-28,20.86-28.16C351.27,201.8,316.3,210.08,315.62,225.36Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.37,227.65C313.85,240.44,296,248,286.85,243s-12.78-22.78-23.54-22.13C276.62,209.9,301.06,215.2,307.37,227.65Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288,348.35h-.07a1.75,1.75,0,0,1-1.67-1.8c0-.26.77-26.16-13.78-29.29a1.73,1.73,0,1,1,.73-3.39c17.39,3.73,16.57,31.62,16.52,32.81A1.73,1.73,0,0,1,288,348.35Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.1,311.3c4.52,8.38-9.34,18.59-16.19,17s-9-14.62-17.23-11.48C260.22,305,278.7,303.15,283.1,311.3Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.79,323.85a1.64,1.64,0,0,1-.38,0,1.75,1.75,0,0,1-1.32-2.07c.26-1.18,6.6-28.95,25.54-36.34a1.74,1.74,0,1,1,1.26,3.24c-17.23,6.72-23.35,33.58-23.41,33.85A1.73,1.73,0,0,1,289.79,323.85Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.59,276.32c-13.65,7.14-4.44,22.4,6.2,23s25.3-12.09,33.47-6.07C346.92,277.52,323.89,269.37,310.59,276.32Z",
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.77,216.09h0a2.05,2.05,0,0,1-.43-2.86L283.4,96.15a2.05,2.05,0,0,1,2.86-.43h0a2.05,2.05,0,0,1,.43,2.86L200.63,215.65A2,2,0,0,1,197.77,216.09Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.58,
    y: 151.78,
    width: 5.41,
    height: 1.02,
    transform: "matrix(0.59, -0.81, 0.81, 0.59, 10.69, 325.72)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.57,146l-.83-.6a6.51,6.51,0,0,0-1.38-9.08l-21.92-16.11.6-.82L331,135.47A7.52,7.52,0,0,1,332.57,146Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296,183.09l-96-70.55a3.94,3.94,0,0,1-.84-5.51l28.22-38.39a3.93,3.93,0,0,1,5.51-.84l96,70.55a3.93,3.93,0,0,1,.84,5.5l-28.22,38.4A3.93,3.93,0,0,1,296,183.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.28,184.37a4.47,4.47,0,0,1-2.63-.86l-96-70.56a4.43,4.43,0,0,1-.95-6.22l28.22-38.4a4.46,4.46,0,0,1,6.22-1l96,70.56a4.47,4.47,0,0,1,1.76,2.91,4.4,4.4,0,0,1-.82,3.31l-28.22,38.4a4.47,4.47,0,0,1-2.91,1.76A5.31,5.31,0,0,1,298.28,184.37Zm-2-1.69A3.41,3.41,0,0,0,301,182l28.23-38.4a3.42,3.42,0,0,0-.73-4.78l-96-70.56a3.41,3.41,0,0,0-4.78.73l-28.23,38.4a3.43,3.43,0,0,0-.63,2.54,3.38,3.38,0,0,0,1.36,2.24Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.37,96.43l4.72,3a4.23,4.23,0,0,0-.64,2.11,3.1,3.1,0,0,0,1.41,2.47,2.88,2.88,0,0,0,1.91.67,1.77,1.77,0,0,0,1.36-.7,1.75,1.75,0,0,0,.26-1.45,7.42,7.42,0,0,0-1.77-2.67,13,13,0,0,1-3.08-5.13,4.68,4.68,0,0,1,.84-4,5,5,0,0,1,2.33-1.72A5.52,5.52,0,0,1,229,89a11.73,11.73,0,0,1,4.21,2.17,9.56,9.56,0,0,1,3.68,4.38,5.84,5.84,0,0,1-.72,4.83l-4.66-3a2.59,2.59,0,0,0-.86-3.68,2.37,2.37,0,0,0-1.51-.57,1.31,1.31,0,0,0-1,.55,1,1,0,0,0-.14.91,4.68,4.68,0,0,0,1.17,1.73,24.33,24.33,0,0,1,3.46,4.63,5.77,5.77,0,0,1,.7,3.13,5.36,5.36,0,0,1-1.05,2.72,6,6,0,0,1-2.82,2.12,6.3,6.3,0,0,1-3.66.21,11.16,11.16,0,0,1-4.17-2.07c-2.61-1.91-4-3.74-4.31-5.48A7.42,7.42,0,0,1,218.37,96.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236,105.38a9,9,0,0,1,13.75-2.12q3.83,2.82,4.39,6.39a9.6,9.6,0,0,1-2.17,7.28,11.7,11.7,0,0,1-4.14,3.75,8,8,0,0,1-4.58.75,10.71,10.71,0,0,1-5-2.17,12.09,12.09,0,0,1-3.68-4,8,8,0,0,1-.84-4.64A10.73,10.73,0,0,1,236,105.38Zm4.72,3.5a6.38,6.38,0,0,0-1.59,4,4,4,0,0,0,4.69,3.49c1.05-.25,2.2-1.24,3.46-3a5.85,5.85,0,0,0,1.45-3.81,3.7,3.7,0,0,0-1.63-2.74,3.59,3.59,0,0,0-3-.67A6.4,6.4,0,0,0,240.69,108.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.84,126.64l11.27-15.34,7.89,5.81a14,14,0,0,1,3.08,2.84,4.42,4.42,0,0,1,.85,2.77,5.81,5.81,0,0,1-3.28,4.81,5.19,5.19,0,0,1-2.6.4,7.3,7.3,0,0,1-2.11-.61,5.67,5.67,0,0,1,.82,1.47,6,6,0,0,1,.17,1.36,8.37,8.37,0,0,1,0,1.44l-1,6.13-5.35-3.93.91-6.55a4.47,4.47,0,0,0,0-1.81,2.5,2.5,0,0,0-.9-1.21l-.42-.31-4.57,6.22ZM260.3,121l2,1.47a8.34,8.34,0,0,0,1.41.72,1.6,1.6,0,0,0,1.12.08,1.93,1.93,0,0,0,1.32-2.16,3.52,3.52,0,0,0-1.48-1.69l-2.08-1.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.5,138.88l11.27-15.33,7.89,5.8a14.2,14.2,0,0,1,3.08,2.85,4.46,4.46,0,0,1,.85,2.77,5.29,5.29,0,0,1-1.12,3,5.23,5.23,0,0,1-2.16,1.8,5.3,5.3,0,0,1-2.6.4,7.06,7.06,0,0,1-2.11-.62,6,6,0,0,1,.82,1.47,6.16,6.16,0,0,1,.17,1.37,8.46,8.46,0,0,1,0,1.44l-1,6.13L275.23,146l.91-6.54a4.52,4.52,0,0,0,0-1.82,2.55,2.55,0,0,0-.9-1.21l-.42-.3-4.57,6.22ZM277,133.26l2,1.47a7.81,7.81,0,0,0,1.41.71,1.55,1.55,0,0,0,1.12.09,1.83,1.83,0,0,0,.95-.67,1.77,1.77,0,0,0,.37-1.49,3.53,3.53,0,0,0-1.48-1.7l-2.08-1.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.9,133.94l5.26,3.86-.72,7.45,6.9-2.9,5.24,3.85-12.51,4.53-4.72,6.42-4.75-3.49,4.72-6.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.83,147.12l4.55,3.34-2.57,3.5-6,6.37L302,158.26l4.3-7.65Zm-8.35,11.69,4.24,3.12L302,165.69l-4.24-3.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.45,146.34c.39.84.65,1.44.94,2.14s.54,1.35.8,2c.52,1.34,1,2.7,1.4,4.06a80.07,80.07,0,0,1,2.12,8.3c.3,1.4.53,2.82.76,4.24s.38,2.87.49,4.32a66.09,66.09,0,0,1,.19,8.8l0,.5a4.19,4.19,0,0,1-.14.95,17.58,17.58,0,0,1-2.54,5.54,32.36,32.36,0,0,1-3,3.77,56.53,56.53,0,0,1-6.29,5.9c-2.16,1.75-4.37,3.37-6.63,4.88a81.37,81.37,0,0,1-7,4.2,3.83,3.83,0,0,1-4.6-6l.08-.09,5.18-5.59c1.71-1.88,3.39-3.75,5-5.64a65.9,65.9,0,0,0,4.3-5.63,19.48,19.48,0,0,0,1.52-2.63,4.2,4.2,0,0,0,.52-1.63l-.15,1.46c-.2-2.32-.44-4.64-.87-7s-.91-4.68-1.53-7-1.28-4.67-2-7c-.38-1.15-.79-2.29-1.18-3.42l-.62-1.67-.58-1.52-.15-.39a7.64,7.64,0,0,1,14.07-5.92Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.74,89.2c-6.47,6.2-5.66,36.51-3,65.35s27.09,24.07,36.16,11.57c12-16.62-1.5-41.5.44-51.3,2.11-10.65,3.69-22.7-9.09-30C184.37,76.87,172.34,82.87,173.74,89.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.18,157.29h-.05a.55.55,0,0,1-.49-.6c.81-8,.07-18.41-.64-28.47-1.34-18.9-2.61-36.76,5.88-39.54a.54.54,0,0,1,.69.35.55.55,0,0,1-.35.69c-7.67,2.51-6.38,20.77-5.13,38.43.72,10.1,1.46,20.54.64,28.65A.55.55,0,0,1,169.18,157.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.16,150.83l-2.47,7c-.83,2.37-1.61,4.74-2.38,7.1s-1.47,4.72-2.11,7-1.18,4.63-1.57,6.83l0-1.14a10.79,10.79,0,0,0,.49,3.66c.22.67.48,1.36.79,2.08s.72,1.41,1.14,2.14a36.16,36.16,0,0,0,3,4.31c.57.71,1.17,1.42,1.8,2.11l1.83,2,.4.43a3.81,3.81,0,0,1-4.27,6.08c-.66-.28-1.14-.47-1.68-.72s-1-.49-1.55-.76q-1.51-.8-3-1.74a34.73,34.73,0,0,1-5.52-4.45,27.91,27.91,0,0,1-4.64-6.12,26.07,26.07,0,0,1-1.68-3.83,22.31,22.31,0,0,1-1-4.31,2.83,2.83,0,0,1,0-.5l0-.64a86.51,86.51,0,0,1,2.86-16.69c.68-2.65,1.49-5.25,2.33-7.83s1.75-5.06,2.86-7.7a7.64,7.64,0,0,1,14.26,5.48Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178,135.78c-8,1.51-9.67,4.77-15.54,16.88,1.77,8,12.91,15,12.91,15S191.12,146.09,178,135.78Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.32,150.87c-.13,4.25.29,9.39,1.24,19.5.65,8.57-1.49,24.86,1.21,26H211c.87-12.27.55-20.72,8.31-48.11a10.08,10.08,0,0,0-8.62-13.1c-1.72-.17-3.53-.32-5.4-.41a138,138,0,0,0-19.62,0c-2.13.2-4.34.47-6.46.76A16.28,16.28,0,0,0,165.32,150.87Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,145.33c-.22.81-.7,1.38-1,1.28s-.46-.83-.23-1.64.69-1.37,1.05-1.27S185.24,144.53,185,145.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.42,152c-.11.83-.49,1.47-.85,1.42s-.58-.75-.48-1.58.48-1.47.85-1.42S183.52,151.18,183.42,152Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.13,113.39c-.19,6.53-1,17.2,3.08,21.41,0,0-6-.89-18.68,7-3.68-5.28-.95-7-.95-7,3.62-.66,6.78-4.34,4.8-8.91Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.2,140.18c4.18.59,5.49,6.91,5.49,6.91s10-7.11,13.23-12.12a41.23,41.23,0,0,1-3.67-2.33S190.64,137.76,188.2,140.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.22,139.5s-3.32.72-5,5.34c-1-9.21,3.41-10.06,3.41-10.06a5.37,5.37,0,0,1,3.78-.54A4.47,4.47,0,0,0,184.22,139.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.78,122l-1.65,1-2.75,2.92a6.29,6.29,0,0,1,.27,4.76c3.13-1.22,6.29-3.67,7.13-6.32v-.06A2,2,0,0,0,193.78,122Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199,98.08c3,9.92,4.5,14,1.6,21.07-4.35,10.57-16.81,12.69-22.64,4-5.24-7.82-9.3-22.74-1.54-30.58S196,88.15,199,98.08Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.5,107.06c.29.82.11,1.66-.4,1.88s-1.16-.27-1.45-1.09-.11-1.67.4-1.89S185.21,106.23,185.5,107.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176,111.33c.29.82.11,1.67-.4,1.89s-1.15-.27-1.44-1.1-.11-1.66.4-1.88S175.69,110.51,176,111.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.78,110.19l-2.07.23S174.21,111.55,174.78,110.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.78,110.86a25.82,25.82,0,0,1-.93,6.45c1.39.57,3-.65,3-.65Z",
    style: {
      fill: "#a02724"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.32,116.78a8,8,0,0,1,1.43-.15.24.24,0,0,1,.24.25.28.28,0,0,1-.27.26,7.24,7.24,0,0,0-5.61,2.78.24.24,0,1,1-.4-.27A7.54,7.54,0,0,1,185.32,116.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.15,104.58a7.13,7.13,0,0,1-2,5.39c-1.79,1.67-4-.25-4.57-3-.52-2.5-.21-6.37,2.11-6.94S204.08,101.91,204.15,104.58Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191,88.3c-7.5,8.06,2.56,27.14,1.53,40.86-1.25,16.82,9.06,19.29,15.55,5.82-4.83-12.74.16-31.82-1.14-38.51C205.43,88.8,196.33,84.56,191,88.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.29,100.35a.47.47,0,0,1,.37.11,3.71,3.71,0,0,0,3.42.88.47.47,0,0,1,.6.33.56.56,0,0,1-.36.65,4.66,4.66,0,0,1-4.34-1.07.53.53,0,0,1,.31-.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.42,108.57a.48.48,0,0,1-.37,0,.52.52,0,0,1-.28-.66,5.35,5.35,0,0,1,3.31-3.37.46.46,0,0,1,.58.37.53.53,0,0,1-.38.63,4.3,4.3,0,0,0-2.59,2.7A.53.53,0,0,1,171.42,108.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.29,105.91l-2.07.24S183.72,107.28,184.29,105.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.08,135.26c7,1.09,9.85,3.23,15.6,17.37-2.61,5.27-14.29,18.62-14.29,18.62S202.28,145.56,211.08,135.26Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.32,409c4.18-6.67,4.37-8.51,7.09-12,2.32-3,2.33-2.77,5.18-5.35,1.89-1.71.33-4.16-1.73-5.2-1.61-.8-3.36-1.51-5.3-2.58l-7.42,6.73c1.29,3.83.57,11.8-2.25,17.09C211.88,411.46,216.65,411.66,218.32,409Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.77,196.42s-1,53.91-2.23,90.69a44.59,44.59,0,0,0,4.66,21.29c13,26.1,45.4,82.83,45.4,82.83,1.3,1.14,7.5-5.54,8-7.38,0,0-17.62-71.69-33.24-87.75,20.76-57.45,15.12-99.68,15.12-99.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M205.62,198l-20.37,1.44s3.32,59.21,6.56,92.41C208.59,243,206.36,206,205.62,198Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M192.5,298.67c1.82,17,3.7,39.18,4.55,59.64,6.68,12,12.67,22.57,15.94,28.32,1.59-7.13,3.29-15.64,4.65-24.66C211.62,341.11,201.87,311.1,192.5,298.67Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M211.62,388.43c.73.92,2,2.56,2.94,3.82a1,1,0,0,0,1.3.21,64.92,64.92,0,0,0,8.7-8.24.94.94,0,0,0,.11-1.08l-2.12-3.77a.94.94,0,0,0-1.42-.25l-9.39,8A.93.93,0,0,0,211.62,388.43Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.62,388.43c.73.92,2,2.56,2.94,3.82a1,1,0,0,0,1.3.21,64.92,64.92,0,0,0,8.7-8.24.94.94,0,0,0,.11-1.08l-2.12-3.77a.94.94,0,0,0-1.42-.25l-9.39,8A.93.93,0,0,0,211.62,388.43Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.4,416.23c8,0,11.06-.13,15.58-.28,3.86-.13,4.74.35,7.84.28,2.59-.06,2.72-2.53,2.18-5.38-.27-1.43-.73-3.18-1.07-5.49H203.77c-1.94,3.15-9.06,5.52-13.63,6.12C185.79,412.06,188.21,416.23,191.4,416.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.07,196.42S191.64,265.65,196.25,297c4.84,33,10.8,86.44,7.52,108.33,1.78,1.09,8.36,1.16,12.16,0,0,0,16.75-71.87,3.17-106.87,9.13-77.12-4.38-81.14-8.11-102.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.27,400.8a33.12,33.12,0,0,1-.83,4.5.84.84,0,0,0,.68,1.1c4.39.72,10.92-.32,13-.68a1,1,0,0,0,.82-.78l1.05-4.2a.85.85,0,0,0-.85-1.09l-12.87.25A1,1,0,0,0,203.27,400.8Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.27,400.8a33.12,33.12,0,0,1-.83,4.5.84.84,0,0,0,.68,1.1c4.39.72,10.92-.32,13-.68a1,1,0,0,0,.82-.78l1.05-4.2a.85.85,0,0,0-.85-1.09l-12.87.25A1,1,0,0,0,203.27,400.8Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.84,86.78c8.51,12.32-15,7.89-20.12,19.47C170.74,94.67,171.7,85.73,190.84,86.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211,196.42c-12.41,2.62-38.28,8.64-43.22,0C171,194.21,203.82,194.61,211,196.42Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.34,203.2c-.82,0-1.59,0-2.29-.06-8.08-.42-10.39-2.9-10.48-3a.26.26,0,0,1,0-.38.27.27,0,0,1,.38,0s2.3,2.41,10.11,2.83,25.6-1.78,31-4.3a.29.29,0,0,1,.37.13.29.29,0,0,1-.14.37C205.22,201.18,190.11,203.2,181.34,203.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.38,222.74a1.27,1.27,0,0,1-.74-.27c-4-2.82-.21-16.61,1.92-20.37a.28.28,0,0,1,.52.11c.15,1.93,1.43,18.88-1.22,20.4A.94.94,0,0,1,178.38,222.74Zm1.22-19.51c-2.1,4.59-5,16.47-1.65,18.79.34.24.53.18.64.12C180.29,221.16,180.14,210.65,179.6,203.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.61,219.47a1.76,1.76,0,0,1-.61-.13c-4.62-1.82-3.62-13.17-2.46-17.18a.29.29,0,0,1,.25-.2.3.3,0,0,1,.27.18c.55,1.54,5.31,15.06,3.26,17.05A1,1,0,0,1,182.61,219.47Zm-2.77-16.3c-1.07,4.65-1.48,14.15,2.36,15.66.5.2.68,0,.74,0C184.24,217.54,181.9,209.07,179.84,203.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.39,212.77a.27.27,0,0,1-.27-.23c-.48-3.07,2.48-9.88,4.6-10.56a.26.26,0,0,1,.34.17.28.28,0,0,1-.17.35c-1.86.59-4.66,7.2-4.23,10a.28.28,0,0,1-.23.31Z",
    style: {
      fill: "#fff"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSorry);
export default __webpack_public_path__ + "static/media/sorry.63ab250cb28b9fa6b84c80b806c8734e.svg";
export { ForwardRef as ReactComponent };